import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import func from '../../services/functions'
import { faChevronLeft, faChevronRight, faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FilePreview from "./columns/FilePreview";
import mainAxios from "../../services/mainAxios";
import Loader from "../Layout/Loader";


const PurchaseDocumentPreview = ({
  purchaseAttachments,
  isDesktop,
  purchaseId,
  isDrag
}) => {
  const { t } = useTranslation("translations");
  const [currentDocumentIndex, setCurrentDocumentIndex] = useState(0)
  const [loadingDocument, setLoadingDocument] = useState(false);
  const [filePreview, setFilePreview] = useState(null)

  const decrementPage = () => {
    if (currentDocumentIndex > 0 && !loadingDocument) {
      setCurrentDocumentIndex(val => {
        val--;
        return val
      })
    }
  }

  const incrementPage = () => {
    if (currentDocumentIndex < purchaseAttachments?.length - 1 && !loadingDocument) {
      setCurrentDocumentIndex(val => {
        val++;
        return val
      })
    }
  }

  useEffect(() => {
    if (purchaseAttachments?.length > 0) {
      setLoadingDocument(true)
      let id = purchaseAttachments[currentDocumentIndex].id
      let documentType = purchaseAttachments[currentDocumentIndex].documentType
      let name=purchaseAttachments[currentDocumentIndex].name ?? Date.now()+"."+documentType

      mainAxios
        .post("endpoint/v2/getAtachementByte", {
          value:id
        })
        .then((res) => {
          setLoadingDocument(false)

          if (res?.data?.status) {
            setFilePreview({
              name,
              documentType,
              base64: res.data.content[0]
            })
          }
        });
    }

  }, [currentDocumentIndex, purchaseAttachments?.length,purchaseId])


  return (
    <div className="card border-0 shadow-sm mb-3 sticky">
      <div className="d-flex justify-content-between header border-bottom py-2 px-3">
        <label className="fw-bold mb-0" style={{fontSize:"16px", fontWeight:600}}>
          {t("invoice.documentPreview")}
        </label>
      </div>

      <div className="px-3 py-3">
        {(purchaseAttachments?.length > 0) &&
          <div className="purchase-doc-nav">
            <div className="purchase-doc-name">
              {filePreview?.name}
            </div>
            <div className="purchase-doc-controls">
              <span className="purchase-doc-count">
                {t("invoice.document")} {(currentDocumentIndex + 1)} of {purchaseAttachments?.length > 0 ? purchaseAttachments?.length : 1}
              </span>
              <FontAwesomeIcon onClick={decrementPage} size="1x" icon={faChevronLeft} className="mr-2" style={{cursor:"pointer"}} />
              <FontAwesomeIcon onClick={incrementPage} size="1x" icon={faChevronRight} className="mr-3" style={{cursor:"pointer"}} />
              {filePreview?.base64 && <a
                href={
                  "data:application/pkcs12;base64," +
                  filePreview?.base64
                }
                download={filePreview?.name ?? ""}
                className="nav-link d-inline-block p-0"
              >
                <div className="d-flex align-items-center" style={{fontSize:"13px"}}>
                  <FontAwesomeIcon
                    icon={faDownload}
                    className="mr-1"
                  />
                  {t("company.download")}
                </div>
              </a>}
            </div>
          </div>
        }
        {loadingDocument ?
          <div className="purchase-doc-loader">
            <Loader size="small" />
          </div> :
          isDrag && !loadingDocument && filePreview?
          (
            <div className="d-flex align-items-center justify-content-center h-100" style={{position: "relative"}}>
              <img height="500px" width="100%" src={"/pdf-blur.png"} style={{objectFit:"cover"}}/>
              <div style={{left:0,right:0,bottom:0,top:0,position:"absolute",backgroundColor:"black",opacity:0.3}}/>
            </div>
          ):
          !loadingDocument && filePreview?.documentType=="pdf" ? <FilePreview filePreview={filePreview} isDesktop={isDesktop}/>
            : <h5 className="text-center">{t("invoice.shouldExtractPdf")}</h5>
        }
      </div>
    </div>
  );
};

export default React.memo(PurchaseDocumentPreview);
